var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import firebase from 'firebase/app';
export class NGData {
    init(db, aid) {
        this._collection = db.collection('apps').doc(aid).collection('data');
    }
    save(value) {
        return __awaiter(this, void 0, void 0, function* () {
            if (value.id) {
                return this._collection.doc(value.id).set(Object.assign(Object.assign({}, value), { updatedAt: firebase.firestore.FieldValue.serverTimestamp() }));
            }
            else {
                const docRef = yield this._collection.add(Object.assign(Object.assign({}, value), { createdAt: firebase.firestore.FieldValue.serverTimestamp() }));
                value.id = docRef.id;
            }
        });
    }
    get(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const snap = yield this._collection.where('name', '==', name).get();
            if (snap.docs.length === 0) {
                return;
            }
            return toData(snap.docs[0]);
        });
    }
    remove(id) {
        return this._collection.doc(id).delete();
    }
    all() {
        return __awaiter(this, void 0, void 0, function* () {
            const snap = yield this._collection.get();
            return snap.docs.map(toData);
        });
    }
}
function toData(doc) {
    const result = doc.data();
    result.id = doc.id;
    delete result.createdAt;
    delete result.updatedAt;
    return result;
}
//# sourceMappingURL=NGData.js.map